export default __webpack_public_path__ + "6e4971b688daf3a68587a127fa6610d0.png";